/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsassistantundone2Inputs */

const en_statsassistantundone2 = /** @type {(inputs: Statsassistantundone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undone`)
};

const de_statsassistantundone2 = /** @type {(inputs: Statsassistantundone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurückgenommen`)
};

/**
* | output |
* | --- |
* | "Undone" |
*
* @param {Statsassistantundone2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsassistantundone2 = /** @type {((inputs?: Statsassistantundone2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsassistantundone2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsassistantundone2(inputs)
	return de_statsassistantundone2(inputs)
});
export { statsassistantundone2 as "statsAssistantUndone" }